import { login as cognitoLogin, refresh as cognitoRefresh } from './cognito';
const STORAGE_KEY = 'tl.outlook.session.v1';
let current = loadFromStorage();
function loadFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        return null;
    }
}
function persist(s) {
    current = s;
    if (s)
        localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
    else
        localStorage.removeItem(STORAGE_KEY);
}
export function getSession() {
    return current;
}
export function isAuthenticated() {
    return !!current && current.expiresAt > Date.now() + 30000;
}
export async function loginWithPassword(email, password) {
    const r = await cognitoLogin(email, password);
    const s = {
        idToken: r.IdToken,
        refreshToken: r.RefreshToken,
        expiresAt: Date.now() + r.ExpiresIn * 1000,
        email,
        source: 'cognito',
    };
    persist(s);
    return s;
}
/**
 * Stores a token obtained through the Office login dialog.
 *
 * `expiresInSec` comes from the token's own `exp` claim rather than a fixed guess: a Cognito
 * Hosted UI token lasts about an hour, while the backend's SAML JWT is good for 720h, and the
 * add-in should not make a user re-authenticate a month early.
 */
export function setSsoSession(idToken, source = 'sso', expiresInSec = 3600) {
    const s = {
        idToken,
        expiresAt: Date.now() + expiresInSec * 1000,
        source,
    };
    persist(s);
    return s;
}
export async function getAuthToken() {
    if (!current)
        throw new Error('Not authenticated');
    if (current.expiresAt > Date.now() + 30000)
        return current.idToken;
    if (current.source === 'cognito' && current.refreshToken && current.email) {
        const r = await cognitoRefresh(current.email, current.refreshToken);
        persist({ ...current, idToken: r.IdToken, expiresAt: Date.now() + r.ExpiresIn * 1000 });
        return r.IdToken;
    }
    // Hosted UI and SAML sessions carry no refresh grant — the caller must re-open the dialog.
    throw new Error('Session expired, please sign in again');
}
export function logout() {
    persist(null);
}
